import store from "@/store/index";
import ApiService from "@/services/ApiService";

export default function auth({ next, router, to }) {
  //we're making a request to a route that should throw a 401 if we're not logged in
  ApiService.isLoggedIn()
    .then((response) => {
      if (response.data.logged_in) {
        store.commit("user/setLoggedIn");

        if (!response.data.consentGiven) {
          return router.push({ name: "Consent" });
        }

        return next();
      } else {
        store.commit("user/setPostLoginDestination", to);
        store.commit("user/setLoggedOut");
        router.push({ name: "Login" });
      }
    })
    .catch((error) => {
      console.log(error);
      store.commit("user/setPostLoginDestination", to);
      store.commit("user/setLoggedOut");
      router.push({ name: "Login" });
    });
}
